export const API_URL = process.env.REACT_APP_URL_API
export const API_URL_COMPLIANCE = process.env.REACT_APP_URL_COMPLIANCE
export const API_IQQA = process.env.REACT_APP_URL_API_IQQA
export const API_FEES = process.env.REACT_APP_URL_FEES
